var dt = Object.defineProperty;
var pt = (s, i, o) => i in s ? dt(s, i, { enumerable: !0, configurable: !0, writable: !0, value: o }) : s[i] = o;
var ue = (s, i, o) => (pt(s, typeof i != "symbol" ? i + "" : i, o), o);
import { verifyMessage as Oe } from "ethers";
function Z() {
}
function be(s) {
  return s();
}
function De() {
  return /* @__PURE__ */ Object.create(null);
}
function re(s) {
  s.forEach(be);
}
function we(s) {
  return typeof s == "function";
}
function Pe(s, i) {
  return s != s ? i == i : s !== i || s && typeof s == "object" || typeof s == "function";
}
function yt(s) {
  return Object.keys(s).length === 0;
}
function de(s, i) {
  s.appendChild(i);
}
function Ne(s, i, o) {
  const h = gt(s);
  if (!h.getElementById(i)) {
    const l = oe("style");
    l.id = i, l.textContent = o, mt(h, l);
  }
}
function gt(s) {
  if (!s)
    return document;
  const i = s.getRootNode ? s.getRootNode() : s.ownerDocument;
  return i && /** @type {ShadowRoot} */
  i.host ? (
    /** @type {ShadowRoot} */
    i
  ) : s.ownerDocument;
}
function mt(s, i) {
  return de(
    /** @type {Document} */
    s.head || s,
    i
  ), i.sheet;
}
function We(s, i, o) {
  s.insertBefore(i, o || null);
}
function Ee(s) {
  s.parentNode && s.parentNode.removeChild(s);
}
function oe(s) {
  return document.createElement(s);
}
function wt(s) {
  return document.createTextNode(s);
}
function Et() {
  return wt(" ");
}
function xt(s, i, o, h) {
  return s.addEventListener(i, o, h), () => s.removeEventListener(i, o, h);
}
function N(s, i, o) {
  o == null ? s.removeAttribute(i) : s.getAttribute(i) !== o && s.setAttribute(i, o);
}
function _t(s) {
  return Array.from(s.childNodes);
}
let ee;
function J(s) {
  ee = s;
}
function Bt() {
  if (!ee)
    throw new Error("Function called outside component initialization");
  return ee;
}
function vt(s) {
  Bt().$$.on_destroy.push(s);
}
const Q = [], Me = [];
let Y = [];
const ke = [], It = /* @__PURE__ */ Promise.resolve();
let pe = !1;
function Ft() {
  pe || (pe = !0, It.then(Ve));
}
function ye(s) {
  Y.push(s);
}
const le = /* @__PURE__ */ new Set();
let q = 0;
function Ve() {
  if (q !== 0)
    return;
  const s = ee;
  do {
    try {
      for (; q < Q.length; ) {
        const i = Q[q];
        q++, J(i), St(i.$$);
      }
    } catch (i) {
      throw Q.length = 0, q = 0, i;
    }
    for (J(null), Q.length = 0, q = 0; Me.length; )
      Me.pop()();
    for (let i = 0; i < Y.length; i += 1) {
      const o = Y[i];
      le.has(o) || (le.add(o), o());
    }
    Y.length = 0;
  } while (Q.length);
  for (; ke.length; )
    ke.pop()();
  pe = !1, le.clear(), J(s);
}
function St(s) {
  if (s.fragment !== null) {
    s.update(), re(s.before_update);
    const i = s.dirty;
    s.dirty = [-1], s.fragment && s.fragment.p(s.ctx, i), s.after_update.forEach(ye);
  }
}
function $t(s) {
  const i = [], o = [];
  Y.forEach((h) => s.indexOf(h) === -1 ? i.push(h) : o.push(h)), o.forEach((h) => h()), Y = i;
}
const ne = /* @__PURE__ */ new Set();
let W;
function Ct() {
  W = {
    r: 0,
    c: [],
    p: W
    // parent group
  };
}
function Rt() {
  W.r || re(W.c), W = W.p;
}
function K(s, i) {
  s && s.i && (ne.delete(s), s.i(i));
}
function ge(s, i, o, h) {
  if (s && s.o) {
    if (ne.has(s))
      return;
    ne.add(s), W.c.push(() => {
      ne.delete(s), h && (o && s.d(1), h());
    }), s.o(i);
  } else
    h && h();
}
function At(s) {
  s && s.c();
}
function He(s, i, o) {
  const { fragment: h, after_update: l } = s.$$;
  h && h.m(i, o), ye(() => {
    const f = s.$$.on_mount.map(be).filter(we);
    s.$$.on_destroy ? s.$$.on_destroy.push(...f) : re(f), s.$$.on_mount = [];
  }), l.forEach(ye);
}
function je(s, i) {
  const o = s.$$;
  o.fragment !== null && ($t(o.after_update), re(o.on_destroy), o.fragment && o.fragment.d(i), o.on_destroy = o.fragment = null, o.ctx = []);
}
function Ut(s, i) {
  s.$$.dirty[0] === -1 && (Q.push(s), Ft(), s.$$.dirty.fill(0)), s.$$.dirty[i / 31 | 0] |= 1 << i % 31;
}
function qe(s, i, o, h, l, f, p = null, c = [-1]) {
  const y = ee;
  J(s);
  const m = s.$$ = {
    fragment: null,
    ctx: [],
    // state
    props: f,
    update: Z,
    not_equal: l,
    bound: De(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(i.context || (y ? y.$$.context : [])),
    // everything else
    callbacks: De(),
    dirty: c,
    skip_bound: !1,
    root: i.target || y.$$.root
  };
  p && p(m.root);
  let w = !1;
  if (m.ctx = o ? o(s, i.props || {}, (E, g, ...x) => {
    const C = x.length ? x[0] : g;
    return m.ctx && l(m.ctx[E], m.ctx[E] = C) && (!m.skip_bound && m.bound[E] && m.bound[E](C), w && Ut(s, E)), g;
  }) : [], m.update(), w = !0, re(m.before_update), m.fragment = h ? h(m.ctx) : !1, i.target) {
    if (i.hydrate) {
      const E = _t(i.target);
      m.fragment && m.fragment.l(E), E.forEach(Ee);
    } else
      m.fragment && m.fragment.c();
    i.intro && K(s.$$.fragment), He(s, i.target, i.anchor), Ve();
  }
  J(y);
}
class ze {
  constructor() {
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    ue(this, "$$");
    /**
     * ### PRIVATE API
     *
     * Do not use, may change at any time
     *
     * @type {any}
     */
    ue(this, "$$set");
  }
  /** @returns {void} */
  $destroy() {
    je(this, 1), this.$destroy = Z;
  }
  /**
   * @template {Extract<keyof Events, string>} K
   * @param {K} type
   * @param {((e: Events[K]) => void) | null | undefined} callback
   * @returns {() => void}
   */
  $on(i, o) {
    if (!we(o))
      return Z;
    const h = this.$$.callbacks[i] || (this.$$.callbacks[i] = []);
    return h.push(o), () => {
      const l = h.indexOf(o);
      l !== -1 && h.splice(l, 1);
    };
  }
  /**
   * @param {Partial<Props>} props
   * @returns {void}
   */
  $set(i) {
    this.$$set && !yt(i) && (this.$$.skip_bound = !0, this.$$set(i), this.$$.skip_bound = !1);
  }
}
const Tt = "4";
typeof window < "u" && (window.__svelte || (window.__svelte = { v: /* @__PURE__ */ new Set() })).v.add(Tt);
function Ot(s) {
  Ne(s, "svelte-1g9ykxg", '.cscanapp-close.svelte-1g9ykxg{position:absolute;z-index:10;right:5px;top:5px;width:32px;height:32px;opacity:0.3;cursor:pointer}.cscanapp-close.svelte-1g9ykxg:hover{opacity:1}.cscanapp-close.svelte-1g9ykxg:before,.cscanapp-close.svelte-1g9ykxg:after{position:absolute;left:15px;content:" ";height:33px;width:2px;background-color:#000}.cscanapp-close.svelte-1g9ykxg:before{transform:rotate(45deg)}.cscanapp-close.svelte-1g9ykxg:after{transform:rotate(-45deg)}');
}
function Dt(s) {
  let i, o, h;
  return {
    c() {
      i = oe("div"), N(i, "class", "cscanapp-close svelte-1g9ykxg"), N(i, "role", "button"), N(i, "tabindex", "0");
    },
    m(l, f) {
      We(l, i, f), o || (h = xt(i, "click", function() {
        we(
          /*close*/
          s[0]
        ) && s[0].apply(this, arguments);
      }), o = !0);
    },
    p(l, [f]) {
      s = l;
    },
    i: Z,
    o: Z,
    d(l) {
      l && Ee(i), o = !1, h();
    }
  };
}
function Mt(s, i, o) {
  let { close: h } = i;
  return s.$$set = (l) => {
    "close" in l && o(0, h = l.close);
  }, [h];
}
class kt extends ze {
  constructor(i) {
    super(), qe(this, i, Mt, Dt, Pe, { close: 0 }, Ot);
  }
}
var G = /* @__PURE__ */ ((s) => (s.CAPTURE = "capture", s.ERROR = "error", s.CANCEL = "cancel", s))(G || {}), te = /* @__PURE__ */ ((s) => (s.ROOT = "cscanapp", s.VIDEO = "cscanappVideo", s))(te || {});
function Lt(s) {
  Ne(s, "svelte-1856eye", "#cscanapp.svelte-1856eye.svelte-1856eye{position:relative;width:100%;height:100%;border-radius:inherit}#cscanapp.svelte-1856eye video.svelte-1856eye{width:100%;height:100%;object-fit:cover;position:absolute;border-radius:inherit;display:block}");
}
function Le(s) {
  let i, o;
  return i = new kt({ props: { close: (
    /*close*/
    s[0]
  ) } }), {
    c() {
      At(i.$$.fragment);
    },
    m(h, l) {
      He(i, h, l), o = !0;
    },
    p(h, l) {
      const f = {};
      l & /*close*/
      1 && (f.close = /*close*/
      h[0]), i.$set(f);
    },
    i(h) {
      o || (K(i.$$.fragment, h), o = !0);
    },
    o(h) {
      ge(i.$$.fragment, h), o = !1;
    },
    d(h) {
      je(i, h);
    }
  };
}
function bt(s) {
  let i, o, h, l, f = (
    /*isCloseButton*/
    s[1] && Le(s)
  );
  return {
    c() {
      i = oe("div"), f && f.c(), o = Et(), h = oe("video"), N(h, "id", te.VIDEO), N(h, "class", "svelte-1856eye"), N(i, "id", te.ROOT), N(i, "class", "cscanapp svelte-1856eye");
    },
    m(p, c) {
      We(p, i, c), f && f.m(i, null), de(i, o), de(i, h), l = !0;
    },
    p(p, [c]) {
      /*isCloseButton*/
      p[1] ? f ? (f.p(p, c), c & /*isCloseButton*/
      2 && K(f, 1)) : (f = Le(p), f.c(), K(f, 1), f.m(i, o)) : f && (Ct(), ge(f, 1, 1, () => {
        f = null;
      }), Rt());
    },
    i(p) {
      l || (K(f), l = !0);
    },
    o(p) {
      ge(f), l = !1;
    },
    d(p) {
      p && Ee(i), f && f.d();
    }
  };
}
function Pt(s, i, o) {
  let { close: h } = i, { isCloseButton: l } = i;
  return vt(h), s.$$set = (f) => {
    "close" in f && o(0, h = f.close), "isCloseButton" in f && o(1, l = f.isCloseButton);
  }, [h, l];
}
class Nt extends ze {
  constructor(i) {
    super(), qe(this, i, Pt, bt, Pe, { close: 0, isCloseButton: 1 }, Lt);
  }
}
class _ {
  constructor(i, o, h, l, f) {
    this._legacyCanvasSize = _.DEFAULT_CANVAS_SIZE, this._preferredCamera = "environment", this._maxScansPerSecond = 25, this._lastScanTimestamp = -1, this._destroyed = this._flashOn = this._paused = this._active = !1, this.$video = i, this.$canvas = document.createElement("canvas"), h && typeof h == "object" ? this._onDecode = o : (console.warn(h || l || f ? "You're using a deprecated version of the QrScanner constructor which will be removed in the future" : "Note that the type of the scan result passed to onDecode will change in the future. To already switch to the new api today, you can pass returnDetailedScanResult: true."), this._legacyOnDecode = o), o = typeof h == "object" ? h : {}, this._onDecodeError = o.onDecodeError || (typeof h == "function" ? h : this._onDecodeError), this._calculateScanRegion = o.calculateScanRegion || (typeof l == "function" ? l : this._calculateScanRegion), this._preferredCamera = o.preferredCamera || f || this._preferredCamera, this._legacyCanvasSize = typeof h == "number" ? h : typeof l == "number" ? l : this._legacyCanvasSize, this._maxScansPerSecond = o.maxScansPerSecond || this._maxScansPerSecond, this._onPlay = this._onPlay.bind(this), this._onLoadedMetaData = this._onLoadedMetaData.bind(this), this._onVisibilityChange = this._onVisibilityChange.bind(this), this._updateOverlay = this._updateOverlay.bind(this), i.disablePictureInPicture = !0, i.playsInline = !0, i.muted = !0;
    let p = !1;
    if (i.hidden && (i.hidden = !1, p = !0), document.body.contains(i) || (document.body.appendChild(i), p = !0), h = i.parentElement, o.highlightScanRegion || o.highlightCodeOutline) {
      if (l = !!o.overlay, this.$overlay = o.overlay || document.createElement("div"), f = this.$overlay.style, f.position = "absolute", f.display = "none", f.pointerEvents = "none", this.$overlay.classList.add("scan-region-highlight"), !l && o.highlightScanRegion) {
        this.$overlay.innerHTML = '<svg class="scan-region-highlight-svg" viewBox="0 0 238 238" preserveAspectRatio="none" style="position:absolute;width:100%;height:100%;left:0;top:0;fill:none;stroke:#e9b213;stroke-width:4;stroke-linecap:round;stroke-linejoin:round"><path d="M31 2H10a8 8 0 0 0-8 8v21M207 2h21a8 8 0 0 1 8 8v21m0 176v21a8 8 0 0 1-8 8h-21m-176 0H10a8 8 0 0 1-8-8v-21"/></svg>';
        try {
          this.$overlay.firstElementChild.animate({ transform: [
            "scale(.98)",
            "scale(1.01)"
          ] }, { duration: 400, iterations: 1 / 0, direction: "alternate", easing: "ease-in-out" });
        } catch {
        }
        h.insertBefore(this.$overlay, this.$video.nextSibling);
      }
      o.highlightCodeOutline && (this.$overlay.insertAdjacentHTML("beforeend", '<svg class="code-outline-highlight" preserveAspectRatio="none" style="display:none;width:100%;height:100%;fill:none;stroke:#e9b213;stroke-width:5;stroke-dasharray:25;stroke-linecap:round;stroke-linejoin:round"><polygon/></svg>'), this.$codeOutlineHighlight = this.$overlay.lastElementChild);
    }
    this._scanRegion = this._calculateScanRegion(i), requestAnimationFrame(() => {
      let c = window.getComputedStyle(i);
      c.display === "none" && (i.style.setProperty("display", "block", "important"), p = !0), c.visibility !== "visible" && (i.style.setProperty("visibility", "visible", "important"), p = !0), p && (console.warn("QrScanner has overwritten the video hiding style to avoid Safari stopping the playback."), i.style.opacity = "0", i.style.width = "0", i.style.height = "0", this.$overlay && this.$overlay.parentElement && this.$overlay.parentElement.removeChild(this.$overlay), delete this.$overlay, delete this.$codeOutlineHighlight), this.$overlay && this._updateOverlay();
    }), i.addEventListener("play", this._onPlay), i.addEventListener("loadedmetadata", this._onLoadedMetaData), document.addEventListener("visibilitychange", this._onVisibilityChange), window.addEventListener("resize", this._updateOverlay), this._qrEnginePromise = _.createQrEngine();
  }
  static set WORKER_PATH(i) {
    console.warn("Setting QrScanner.WORKER_PATH is not required and not supported anymore. Have a look at the README for new setup instructions.");
  }
  static async hasCamera() {
    try {
      return !!(await _.listCameras(!1)).length;
    } catch {
      return !1;
    }
  }
  static async listCameras(i = !1) {
    if (!navigator.mediaDevices)
      return [];
    let o = async () => (await navigator.mediaDevices.enumerateDevices()).filter((l) => l.kind === "videoinput"), h;
    try {
      i && (await o()).every((l) => !l.label) && (h = await navigator.mediaDevices.getUserMedia({ audio: !1, video: !0 }));
    } catch {
    }
    try {
      return (await o()).map((l, f) => ({ id: l.deviceId, label: l.label || (f === 0 ? "Default Camera" : `Camera ${f + 1}`) }));
    } finally {
      h && (console.warn("Call listCameras after successfully starting a QR scanner to avoid creating a temporary video stream"), _._stopVideoStream(h));
    }
  }
  async hasFlash() {
    let i;
    try {
      if (this.$video.srcObject) {
        if (!(this.$video.srcObject instanceof MediaStream))
          return !1;
        i = this.$video.srcObject;
      } else
        i = (await this._getCameraStream()).stream;
      return "torch" in i.getVideoTracks()[0].getSettings();
    } catch {
      return !1;
    } finally {
      i && i !== this.$video.srcObject && (console.warn("Call hasFlash after successfully starting the scanner to avoid creating a temporary video stream"), _._stopVideoStream(i));
    }
  }
  isFlashOn() {
    return this._flashOn;
  }
  async toggleFlash() {
    this._flashOn ? await this.turnFlashOff() : await this.turnFlashOn();
  }
  async turnFlashOn() {
    if (!this._flashOn && !this._destroyed && (this._flashOn = !0, this._active && !this._paused))
      try {
        if (!await this.hasFlash())
          throw "No flash available";
        await this.$video.srcObject.getVideoTracks()[0].applyConstraints({ advanced: [{ torch: !0 }] });
      } catch (i) {
        throw this._flashOn = !1, i;
      }
  }
  async turnFlashOff() {
    this._flashOn && (this._flashOn = !1, await this._restartVideoStream());
  }
  destroy() {
    this.$video.removeEventListener("loadedmetadata", this._onLoadedMetaData), this.$video.removeEventListener("play", this._onPlay), document.removeEventListener(
      "visibilitychange",
      this._onVisibilityChange
    ), window.removeEventListener("resize", this._updateOverlay), this._destroyed = !0, this._flashOn = !1, this.stop(), _._postWorkerMessage(this._qrEnginePromise, "close");
  }
  async start() {
    if (this._destroyed)
      throw Error("The QR scanner can not be started as it had been destroyed.");
    if ((!this._active || this._paused) && (window.location.protocol !== "https:" && console.warn("The camera stream is only accessible if the page is transferred via https."), this._active = !0, !document.hidden))
      if (this._paused = !1, this.$video.srcObject)
        await this.$video.play();
      else
        try {
          let { stream: i, facingMode: o } = await this._getCameraStream();
          !this._active || this._paused ? _._stopVideoStream(i) : (this._setVideoMirror(o), this.$video.srcObject = i, await this.$video.play(), this._flashOn && (this._flashOn = !1, this.turnFlashOn().catch(() => {
          })));
        } catch (i) {
          if (!this._paused)
            throw this._active = !1, i;
        }
  }
  stop() {
    this.pause(), this._active = !1;
  }
  async pause(i = !1) {
    if (this._paused = !0, !this._active)
      return !0;
    this.$video.pause(), this.$overlay && (this.$overlay.style.display = "none");
    let o = () => {
      this.$video.srcObject instanceof MediaStream && (_._stopVideoStream(this.$video.srcObject), this.$video.srcObject = null);
    };
    return i ? (o(), !0) : (await new Promise((h) => setTimeout(h, 300)), this._paused ? (o(), !0) : !1);
  }
  async setCamera(i) {
    i !== this._preferredCamera && (this._preferredCamera = i, await this._restartVideoStream());
  }
  static async scanImage(i, o, h, l, f = !1, p = !1) {
    let c, y = !1;
    o && ("scanRegion" in o || "qrEngine" in o || "canvas" in o || "disallowCanvasResizing" in o || "alsoTryWithoutScanRegion" in o || "returnDetailedScanResult" in o) ? (c = o.scanRegion, h = o.qrEngine, l = o.canvas, f = o.disallowCanvasResizing || !1, p = o.alsoTryWithoutScanRegion || !1, y = !0) : console.warn(o || h || l || f || p ? "You're using a deprecated api for scanImage which will be removed in the future." : "Note that the return type of scanImage will change in the future. To already switch to the new api today, you can pass returnDetailedScanResult: true."), o = !!h;
    try {
      let m, w;
      [h, m] = await Promise.all([h || _.createQrEngine(), _._loadImage(i)]), [l, w] = _._drawToCanvas(m, c, l, f);
      let E;
      if (h instanceof Worker) {
        let g = h;
        o || _._postWorkerMessageSync(g, "inversionMode", "both"), E = await new Promise((x, C) => {
          let R, O, A, V = -1;
          O = (D) => {
            D.data.id === V && (g.removeEventListener("message", O), g.removeEventListener("error", A), clearTimeout(R), D.data.data !== null ? x({ data: D.data.data, cornerPoints: _._convertPoints(D.data.cornerPoints, c) }) : C(_.NO_QR_CODE_FOUND));
          }, A = (D) => {
            g.removeEventListener("message", O), g.removeEventListener("error", A), clearTimeout(R), C("Scanner error: " + (D ? D.message || D : "Unknown Error"));
          }, g.addEventListener("message", O), g.addEventListener("error", A), R = setTimeout(() => A("timeout"), 1e4);
          let L = w.getImageData(0, 0, l.width, l.height);
          V = _._postWorkerMessageSync(g, "decode", L, [L.data.buffer]);
        });
      } else
        E = await Promise.race([new Promise((g, x) => window.setTimeout(() => x("Scanner error: timeout"), 1e4)), (async () => {
          try {
            var [g] = await h.detect(l);
            if (!g)
              throw _.NO_QR_CODE_FOUND;
            return { data: g.rawValue, cornerPoints: _._convertPoints(g.cornerPoints, c) };
          } catch (x) {
            if (g = x.message || x, /not implemented|service unavailable/.test(g))
              return _._disableBarcodeDetector = !0, _.scanImage(i, { scanRegion: c, canvas: l, disallowCanvasResizing: f, alsoTryWithoutScanRegion: p });
            throw `Scanner error: ${g}`;
          }
        })()]);
      return y ? E : E.data;
    } catch (m) {
      if (!c || !p)
        throw m;
      let w = await _.scanImage(i, { qrEngine: h, canvas: l, disallowCanvasResizing: f });
      return y ? w : w.data;
    } finally {
      o || _._postWorkerMessage(h, "close");
    }
  }
  setGrayscaleWeights(i, o, h, l = !0) {
    _._postWorkerMessage(this._qrEnginePromise, "grayscaleWeights", {
      red: i,
      green: o,
      blue: h,
      useIntegerApproximation: l
    });
  }
  setInversionMode(i) {
    _._postWorkerMessage(this._qrEnginePromise, "inversionMode", i);
  }
  static async createQrEngine(i) {
    if (i && console.warn("Specifying a worker path is not required and not supported anymore."), i = () => import("./qr-scanner-worker.min-ed2fa316.js").then((h) => h.createWorker()), !(!_._disableBarcodeDetector && "BarcodeDetector" in window && BarcodeDetector.getSupportedFormats && (await BarcodeDetector.getSupportedFormats()).includes("qr_code")))
      return i();
    let o = navigator.userAgentData;
    return o && o.brands.some(({ brand: h }) => /Chromium/i.test(h)) && /mac ?OS/i.test(o.platform) && await o.getHighEntropyValues(["architecture", "platformVersion"]).then(({ architecture: h, platformVersion: l }) => /arm/i.test(h || "arm") && 13 <= parseInt(l || "13")).catch(() => !0) ? i() : new BarcodeDetector({ formats: ["qr_code"] });
  }
  _onPlay() {
    this._scanRegion = this._calculateScanRegion(this.$video), this._updateOverlay(), this.$overlay && (this.$overlay.style.display = ""), this._scanFrame();
  }
  _onLoadedMetaData() {
    this._scanRegion = this._calculateScanRegion(this.$video), this._updateOverlay();
  }
  _onVisibilityChange() {
    document.hidden ? this.pause() : this._active && this.start();
  }
  _calculateScanRegion(i) {
    let o = Math.round(0.6666666666666666 * Math.min(i.videoWidth, i.videoHeight));
    return { x: Math.round((i.videoWidth - o) / 2), y: Math.round((i.videoHeight - o) / 2), width: o, height: o, downScaledWidth: this._legacyCanvasSize, downScaledHeight: this._legacyCanvasSize };
  }
  _updateOverlay() {
    requestAnimationFrame(() => {
      if (this.$overlay) {
        var i = this.$video, o = i.videoWidth, h = i.videoHeight, l = i.offsetWidth, f = i.offsetHeight, p = i.offsetLeft, c = i.offsetTop, y = window.getComputedStyle(i), m = y.objectFit, w = o / h, E = l / f;
        switch (m) {
          case "none":
            var g = o, x = h;
            break;
          case "fill":
            g = l, x = f;
            break;
          default:
            (m === "cover" ? w > E : w < E) ? (x = f, g = x * w) : (g = l, x = g / w), m === "scale-down" && (g = Math.min(g, o), x = Math.min(x, h));
        }
        var [C, R] = y.objectPosition.split(" ").map((A, V) => {
          const L = parseFloat(A);
          return A.endsWith("%") ? (V ? f - x : l - g) * L / 100 : L;
        });
        y = this._scanRegion.width || o, E = this._scanRegion.height || h, m = this._scanRegion.x || 0;
        var O = this._scanRegion.y || 0;
        w = this.$overlay.style, w.width = `${y / o * g}px`, w.height = `${E / h * x}px`, w.top = `${c + R + O / h * x}px`, h = /scaleX\(-1\)/.test(i.style.transform), w.left = `${p + (h ? l - C - g : C) + (h ? o - m - y : m) / o * g}px`, w.transform = i.style.transform;
      }
    });
  }
  static _convertPoints(i, o) {
    if (!o)
      return i;
    let h = o.x || 0, l = o.y || 0, f = o.width && o.downScaledWidth ? o.width / o.downScaledWidth : 1;
    o = o.height && o.downScaledHeight ? o.height / o.downScaledHeight : 1;
    for (let p of i)
      p.x = p.x * f + h, p.y = p.y * o + l;
    return i;
  }
  _scanFrame() {
    !this._active || this.$video.paused || this.$video.ended || ("requestVideoFrameCallback" in this.$video ? this.$video.requestVideoFrameCallback.bind(this.$video) : requestAnimationFrame)(async () => {
      if (!(1 >= this.$video.readyState)) {
        var i = Date.now() - this._lastScanTimestamp, o = 1e3 / this._maxScansPerSecond;
        i < o && await new Promise((l) => setTimeout(l, o - i)), this._lastScanTimestamp = Date.now();
        try {
          var h = await _.scanImage(this.$video, { scanRegion: this._scanRegion, qrEngine: this._qrEnginePromise, canvas: this.$canvas });
        } catch (l) {
          if (!this._active)
            return;
          this._onDecodeError(l);
        }
        !_._disableBarcodeDetector || await this._qrEnginePromise instanceof Worker || (this._qrEnginePromise = _.createQrEngine()), h ? (this._onDecode ? this._onDecode(h) : this._legacyOnDecode && this._legacyOnDecode(h.data), this.$codeOutlineHighlight && (clearTimeout(this._codeOutlineHighlightRemovalTimeout), this._codeOutlineHighlightRemovalTimeout = void 0, this.$codeOutlineHighlight.setAttribute("viewBox", `${this._scanRegion.x || 0} ${this._scanRegion.y || 0} ${this._scanRegion.width || this.$video.videoWidth} ${this._scanRegion.height || this.$video.videoHeight}`), this.$codeOutlineHighlight.firstElementChild.setAttribute(
          "points",
          h.cornerPoints.map(({ x: l, y: f }) => `${l},${f}`).join(" ")
        ), this.$codeOutlineHighlight.style.display = "")) : this.$codeOutlineHighlight && !this._codeOutlineHighlightRemovalTimeout && (this._codeOutlineHighlightRemovalTimeout = setTimeout(() => this.$codeOutlineHighlight.style.display = "none", 100));
      }
      this._scanFrame();
    });
  }
  _onDecodeError(i) {
    i !== _.NO_QR_CODE_FOUND && console.log(i);
  }
  async _getCameraStream() {
    if (!navigator.mediaDevices)
      throw "Camera not found.";
    let i = /^(environment|user)$/.test(this._preferredCamera) ? "facingMode" : "deviceId", o = [{ width: { min: 1024 } }, { width: { min: 768 } }, {}], h = o.map((l) => Object.assign({}, l, { [i]: { exact: this._preferredCamera } }));
    for (let l of [...h, ...o])
      try {
        let f = await navigator.mediaDevices.getUserMedia({ video: l, audio: !1 }), p = this._getFacingMode(f) || (l.facingMode ? this._preferredCamera : this._preferredCamera === "environment" ? "user" : "environment");
        return { stream: f, facingMode: p };
      } catch {
      }
    throw "Camera not found.";
  }
  async _restartVideoStream() {
    let i = this._paused;
    await this.pause(!0) && !i && this._active && await this.start();
  }
  static _stopVideoStream(i) {
    for (let o of i.getTracks())
      o.stop(), i.removeTrack(o);
  }
  _setVideoMirror(i) {
    this.$video.style.transform = "scaleX(" + (i === "user" ? -1 : 1) + ")";
  }
  _getFacingMode(i) {
    return (i = i.getVideoTracks()[0]) ? /rear|back|environment/i.test(i.label) ? "environment" : /front|user|face/i.test(i.label) ? "user" : null : null;
  }
  static _drawToCanvas(i, o, h, l = !1) {
    h = h || document.createElement("canvas");
    let f = o && o.x ? o.x : 0, p = o && o.y ? o.y : 0, c = o && o.width ? o.width : i.videoWidth || i.width, y = o && o.height ? o.height : i.videoHeight || i.height;
    return l || (l = o && o.downScaledWidth ? o.downScaledWidth : c, o = o && o.downScaledHeight ? o.downScaledHeight : y, h.width !== l && (h.width = l), h.height !== o && (h.height = o)), o = h.getContext("2d", { alpha: !1 }), o.imageSmoothingEnabled = !1, o.drawImage(i, f, p, c, y, 0, 0, h.width, h.height), [h, o];
  }
  static async _loadImage(i) {
    if (i instanceof Image)
      return await _._awaitImageLoad(i), i;
    if (i instanceof HTMLVideoElement || i instanceof HTMLCanvasElement || i instanceof SVGImageElement || "OffscreenCanvas" in window && i instanceof OffscreenCanvas || "ImageBitmap" in window && i instanceof ImageBitmap)
      return i;
    if (i instanceof File || i instanceof Blob || i instanceof URL || typeof i == "string") {
      let o = new Image();
      o.src = i instanceof File || i instanceof Blob ? URL.createObjectURL(i) : i.toString();
      try {
        return await _._awaitImageLoad(o), o;
      } finally {
        (i instanceof File || i instanceof Blob) && URL.revokeObjectURL(o.src);
      }
    } else
      throw "Unsupported image type.";
  }
  static async _awaitImageLoad(i) {
    i.complete && i.naturalWidth !== 0 || await new Promise((o, h) => {
      let l = (f) => {
        i.removeEventListener("load", l), i.removeEventListener("error", l), f instanceof ErrorEvent ? h("Image load error") : o();
      };
      i.addEventListener("load", l), i.addEventListener("error", l);
    });
  }
  static async _postWorkerMessage(i, o, h, l) {
    return _._postWorkerMessageSync(await i, o, h, l);
  }
  static _postWorkerMessageSync(i, o, h, l) {
    if (!(i instanceof Worker))
      return -1;
    let f = _._workerMessageId++;
    return i.postMessage({ id: f, type: o, data: h }, l), f;
  }
}
_.DEFAULT_CANVAS_SIZE = 400;
_.NO_QR_CODE_FOUND = "No QR code found";
_._disableBarcodeDetector = !1;
_._workerMessageId = 0;
var me = {}, se = {};
se.byteLength = Ht;
se.toByteArray = qt;
se.fromByteArray = Gt;
var k = [], T = [], Wt = typeof Uint8Array < "u" ? Uint8Array : Array, fe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var z = 0, Vt = fe.length; z < Vt; ++z)
  k[z] = fe[z], T[fe.charCodeAt(z)] = z;
T["-".charCodeAt(0)] = 62;
T["_".charCodeAt(0)] = 63;
function Qe(s) {
  var i = s.length;
  if (i % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var o = s.indexOf("=");
  o === -1 && (o = i);
  var h = o === i ? 0 : 4 - o % 4;
  return [o, h];
}
function Ht(s) {
  var i = Qe(s), o = i[0], h = i[1];
  return (o + h) * 3 / 4 - h;
}
function jt(s, i, o) {
  return (i + o) * 3 / 4 - o;
}
function qt(s) {
  var i, o = Qe(s), h = o[0], l = o[1], f = new Wt(jt(s, h, l)), p = 0, c = l > 0 ? h - 4 : h, y;
  for (y = 0; y < c; y += 4)
    i = T[s.charCodeAt(y)] << 18 | T[s.charCodeAt(y + 1)] << 12 | T[s.charCodeAt(y + 2)] << 6 | T[s.charCodeAt(y + 3)], f[p++] = i >> 16 & 255, f[p++] = i >> 8 & 255, f[p++] = i & 255;
  return l === 2 && (i = T[s.charCodeAt(y)] << 2 | T[s.charCodeAt(y + 1)] >> 4, f[p++] = i & 255), l === 1 && (i = T[s.charCodeAt(y)] << 10 | T[s.charCodeAt(y + 1)] << 4 | T[s.charCodeAt(y + 2)] >> 2, f[p++] = i >> 8 & 255, f[p++] = i & 255), f;
}
function zt(s) {
  return k[s >> 18 & 63] + k[s >> 12 & 63] + k[s >> 6 & 63] + k[s & 63];
}
function Qt(s, i, o) {
  for (var h, l = [], f = i; f < o; f += 3)
    h = (s[f] << 16 & 16711680) + (s[f + 1] << 8 & 65280) + (s[f + 2] & 255), l.push(zt(h));
  return l.join("");
}
function Gt(s) {
  for (var i, o = s.length, h = o % 3, l = [], f = 16383, p = 0, c = o - h; p < c; p += f)
    l.push(Qt(s, p, p + f > c ? c : p + f));
  return h === 1 ? (i = s[o - 1], l.push(
    k[i >> 2] + k[i << 4 & 63] + "=="
  )) : h === 2 && (i = (s[o - 2] << 8) + s[o - 1], l.push(
    k[i >> 10] + k[i >> 4 & 63] + k[i << 2 & 63] + "="
  )), l.join("");
}
var xe = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
xe.read = function(s, i, o, h, l) {
  var f, p, c = l * 8 - h - 1, y = (1 << c) - 1, m = y >> 1, w = -7, E = o ? l - 1 : 0, g = o ? -1 : 1, x = s[i + E];
  for (E += g, f = x & (1 << -w) - 1, x >>= -w, w += c; w > 0; f = f * 256 + s[i + E], E += g, w -= 8)
    ;
  for (p = f & (1 << -w) - 1, f >>= -w, w += h; w > 0; p = p * 256 + s[i + E], E += g, w -= 8)
    ;
  if (f === 0)
    f = 1 - m;
  else {
    if (f === y)
      return p ? NaN : (x ? -1 : 1) * (1 / 0);
    p = p + Math.pow(2, h), f = f - m;
  }
  return (x ? -1 : 1) * p * Math.pow(2, f - h);
};
xe.write = function(s, i, o, h, l, f) {
  var p, c, y, m = f * 8 - l - 1, w = (1 << m) - 1, E = w >> 1, g = l === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, x = h ? 0 : f - 1, C = h ? 1 : -1, R = i < 0 || i === 0 && 1 / i < 0 ? 1 : 0;
  for (i = Math.abs(i), isNaN(i) || i === 1 / 0 ? (c = isNaN(i) ? 1 : 0, p = w) : (p = Math.floor(Math.log(i) / Math.LN2), i * (y = Math.pow(2, -p)) < 1 && (p--, y *= 2), p + E >= 1 ? i += g / y : i += g * Math.pow(2, 1 - E), i * y >= 2 && (p++, y /= 2), p + E >= w ? (c = 0, p = w) : p + E >= 1 ? (c = (i * y - 1) * Math.pow(2, l), p = p + E) : (c = i * Math.pow(2, E - 1) * Math.pow(2, l), p = 0)); l >= 8; s[o + x] = c & 255, x += C, c /= 256, l -= 8)
    ;
  for (p = p << l | c, m += l; m > 0; s[o + x] = p & 255, x += C, p /= 256, m -= 8)
    ;
  s[o + x - C] |= R * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(s) {
  const i = se, o = xe, h = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  s.Buffer = c, s.SlowBuffer = V, s.INSPECT_MAX_BYTES = 50;
  const l = 2147483647;
  s.kMaxLength = l, c.TYPED_ARRAY_SUPPORT = f(), !c.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function f() {
    try {
      const r = new Uint8Array(1), e = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(e, Uint8Array.prototype), Object.setPrototypeOf(r, e), r.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(c.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (c.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(c.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (c.isBuffer(this))
        return this.byteOffset;
    }
  });
  function p(r) {
    if (r > l)
      throw new RangeError('The value "' + r + '" is invalid for option "size"');
    const e = new Uint8Array(r);
    return Object.setPrototypeOf(e, c.prototype), e;
  }
  function c(r, e, t) {
    if (typeof r == "number") {
      if (typeof e == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return E(r);
    }
    return y(r, e, t);
  }
  c.poolSize = 8192;
  function y(r, e, t) {
    if (typeof r == "string")
      return g(r, e);
    if (ArrayBuffer.isView(r))
      return C(r);
    if (r == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof r
      );
    if (M(r, ArrayBuffer) || r && M(r.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (M(r, SharedArrayBuffer) || r && M(r.buffer, SharedArrayBuffer)))
      return R(r, e, t);
    if (typeof r == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const n = r.valueOf && r.valueOf();
    if (n != null && n !== r)
      return c.from(n, e, t);
    const a = O(r);
    if (a)
      return a;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof r[Symbol.toPrimitive] == "function")
      return c.from(r[Symbol.toPrimitive]("string"), e, t);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof r
    );
  }
  c.from = function(r, e, t) {
    return y(r, e, t);
  }, Object.setPrototypeOf(c.prototype, Uint8Array.prototype), Object.setPrototypeOf(c, Uint8Array);
  function m(r) {
    if (typeof r != "number")
      throw new TypeError('"size" argument must be of type number');
    if (r < 0)
      throw new RangeError('The value "' + r + '" is invalid for option "size"');
  }
  function w(r, e, t) {
    return m(r), r <= 0 ? p(r) : e !== void 0 ? typeof t == "string" ? p(r).fill(e, t) : p(r).fill(e) : p(r);
  }
  c.alloc = function(r, e, t) {
    return w(r, e, t);
  };
  function E(r) {
    return m(r), p(r < 0 ? 0 : A(r) | 0);
  }
  c.allocUnsafe = function(r) {
    return E(r);
  }, c.allocUnsafeSlow = function(r) {
    return E(r);
  };
  function g(r, e) {
    if ((typeof e != "string" || e === "") && (e = "utf8"), !c.isEncoding(e))
      throw new TypeError("Unknown encoding: " + e);
    const t = L(r, e) | 0;
    let n = p(t);
    const a = n.write(r, e);
    return a !== t && (n = n.slice(0, a)), n;
  }
  function x(r) {
    const e = r.length < 0 ? 0 : A(r.length) | 0, t = p(e);
    for (let n = 0; n < e; n += 1)
      t[n] = r[n] & 255;
    return t;
  }
  function C(r) {
    if (M(r, Uint8Array)) {
      const e = new Uint8Array(r);
      return R(e.buffer, e.byteOffset, e.byteLength);
    }
    return x(r);
  }
  function R(r, e, t) {
    if (e < 0 || r.byteLength < e)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (r.byteLength < e + (t || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let n;
    return e === void 0 && t === void 0 ? n = new Uint8Array(r) : t === void 0 ? n = new Uint8Array(r, e) : n = new Uint8Array(r, e, t), Object.setPrototypeOf(n, c.prototype), n;
  }
  function O(r) {
    if (c.isBuffer(r)) {
      const e = A(r.length) | 0, t = p(e);
      return t.length === 0 || r.copy(t, 0, 0, e), t;
    }
    if (r.length !== void 0)
      return typeof r.length != "number" || he(r.length) ? p(0) : x(r);
    if (r.type === "Buffer" && Array.isArray(r.data))
      return x(r.data);
  }
  function A(r) {
    if (r >= l)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + l.toString(16) + " bytes");
    return r | 0;
  }
  function V(r) {
    return +r != r && (r = 0), c.alloc(+r);
  }
  c.isBuffer = function(e) {
    return e != null && e._isBuffer === !0 && e !== c.prototype;
  }, c.compare = function(e, t) {
    if (M(e, Uint8Array) && (e = c.from(e, e.offset, e.byteLength)), M(t, Uint8Array) && (t = c.from(t, t.offset, t.byteLength)), !c.isBuffer(e) || !c.isBuffer(t))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (e === t)
      return 0;
    let n = e.length, a = t.length;
    for (let u = 0, d = Math.min(n, a); u < d; ++u)
      if (e[u] !== t[u]) {
        n = e[u], a = t[u];
        break;
      }
    return n < a ? -1 : a < n ? 1 : 0;
  }, c.isEncoding = function(e) {
    switch (String(e).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, c.concat = function(e, t) {
    if (!Array.isArray(e))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (e.length === 0)
      return c.alloc(0);
    let n;
    if (t === void 0)
      for (t = 0, n = 0; n < e.length; ++n)
        t += e[n].length;
    const a = c.allocUnsafe(t);
    let u = 0;
    for (n = 0; n < e.length; ++n) {
      let d = e[n];
      if (M(d, Uint8Array))
        u + d.length > a.length ? (c.isBuffer(d) || (d = c.from(d)), d.copy(a, u)) : Uint8Array.prototype.set.call(
          a,
          d,
          u
        );
      else if (c.isBuffer(d))
        d.copy(a, u);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      u += d.length;
    }
    return a;
  };
  function L(r, e) {
    if (c.isBuffer(r))
      return r.length;
    if (ArrayBuffer.isView(r) || M(r, ArrayBuffer))
      return r.byteLength;
    if (typeof r != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof r
      );
    const t = r.length, n = arguments.length > 2 && arguments[2] === !0;
    if (!n && t === 0)
      return 0;
    let a = !1;
    for (; ; )
      switch (e) {
        case "ascii":
        case "latin1":
        case "binary":
          return t;
        case "utf8":
        case "utf-8":
          return ce(r).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return t * 2;
        case "hex":
          return t >>> 1;
        case "base64":
          return Te(r).length;
        default:
          if (a)
            return n ? -1 : ce(r).length;
          e = ("" + e).toLowerCase(), a = !0;
      }
  }
  c.byteLength = L;
  function D(r, e, t) {
    let n = !1;
    if ((e === void 0 || e < 0) && (e = 0), e > this.length || ((t === void 0 || t > this.length) && (t = this.length), t <= 0) || (t >>>= 0, e >>>= 0, t <= e))
      return "";
    for (r || (r = "utf8"); ; )
      switch (r) {
        case "hex":
          return nt(this, e, t);
        case "utf8":
        case "utf-8":
          return ve(this, e, t);
        case "ascii":
          return rt(this, e, t);
        case "latin1":
        case "binary":
          return it(this, e, t);
        case "base64":
          return et(this, e, t);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return ot(this, e, t);
        default:
          if (n)
            throw new TypeError("Unknown encoding: " + r);
          r = (r + "").toLowerCase(), n = !0;
      }
  }
  c.prototype._isBuffer = !0;
  function P(r, e, t) {
    const n = r[e];
    r[e] = r[t], r[t] = n;
  }
  c.prototype.swap16 = function() {
    const e = this.length;
    if (e % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let t = 0; t < e; t += 2)
      P(this, t, t + 1);
    return this;
  }, c.prototype.swap32 = function() {
    const e = this.length;
    if (e % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let t = 0; t < e; t += 4)
      P(this, t, t + 3), P(this, t + 1, t + 2);
    return this;
  }, c.prototype.swap64 = function() {
    const e = this.length;
    if (e % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let t = 0; t < e; t += 8)
      P(this, t, t + 7), P(this, t + 1, t + 6), P(this, t + 2, t + 5), P(this, t + 3, t + 4);
    return this;
  }, c.prototype.toString = function() {
    const e = this.length;
    return e === 0 ? "" : arguments.length === 0 ? ve(this, 0, e) : D.apply(this, arguments);
  }, c.prototype.toLocaleString = c.prototype.toString, c.prototype.equals = function(e) {
    if (!c.isBuffer(e))
      throw new TypeError("Argument must be a Buffer");
    return this === e ? !0 : c.compare(this, e) === 0;
  }, c.prototype.inspect = function() {
    let e = "";
    const t = s.INSPECT_MAX_BYTES;
    return e = this.toString("hex", 0, t).replace(/(.{2})/g, "$1 ").trim(), this.length > t && (e += " ... "), "<Buffer " + e + ">";
  }, h && (c.prototype[h] = c.prototype.inspect), c.prototype.compare = function(e, t, n, a, u) {
    if (M(e, Uint8Array) && (e = c.from(e, e.offset, e.byteLength)), !c.isBuffer(e))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof e
      );
    if (t === void 0 && (t = 0), n === void 0 && (n = e ? e.length : 0), a === void 0 && (a = 0), u === void 0 && (u = this.length), t < 0 || n > e.length || a < 0 || u > this.length)
      throw new RangeError("out of range index");
    if (a >= u && t >= n)
      return 0;
    if (a >= u)
      return -1;
    if (t >= n)
      return 1;
    if (t >>>= 0, n >>>= 0, a >>>= 0, u >>>= 0, this === e)
      return 0;
    let d = u - a, B = n - t;
    const F = Math.min(d, B), I = this.slice(a, u), S = e.slice(t, n);
    for (let v = 0; v < F; ++v)
      if (I[v] !== S[v]) {
        d = I[v], B = S[v];
        break;
      }
    return d < B ? -1 : B < d ? 1 : 0;
  };
  function _e(r, e, t, n, a) {
    if (r.length === 0)
      return -1;
    if (typeof t == "string" ? (n = t, t = 0) : t > 2147483647 ? t = 2147483647 : t < -2147483648 && (t = -2147483648), t = +t, he(t) && (t = a ? 0 : r.length - 1), t < 0 && (t = r.length + t), t >= r.length) {
      if (a)
        return -1;
      t = r.length - 1;
    } else if (t < 0)
      if (a)
        t = 0;
      else
        return -1;
    if (typeof e == "string" && (e = c.from(e, n)), c.isBuffer(e))
      return e.length === 0 ? -1 : Be(r, e, t, n, a);
    if (typeof e == "number")
      return e = e & 255, typeof Uint8Array.prototype.indexOf == "function" ? a ? Uint8Array.prototype.indexOf.call(r, e, t) : Uint8Array.prototype.lastIndexOf.call(r, e, t) : Be(r, [e], t, n, a);
    throw new TypeError("val must be string, number or Buffer");
  }
  function Be(r, e, t, n, a) {
    let u = 1, d = r.length, B = e.length;
    if (n !== void 0 && (n = String(n).toLowerCase(), n === "ucs2" || n === "ucs-2" || n === "utf16le" || n === "utf-16le")) {
      if (r.length < 2 || e.length < 2)
        return -1;
      u = 2, d /= 2, B /= 2, t /= 2;
    }
    function F(S, v) {
      return u === 1 ? S[v] : S.readUInt16BE(v * u);
    }
    let I;
    if (a) {
      let S = -1;
      for (I = t; I < d; I++)
        if (F(r, I) === F(e, S === -1 ? 0 : I - S)) {
          if (S === -1 && (S = I), I - S + 1 === B)
            return S * u;
        } else
          S !== -1 && (I -= I - S), S = -1;
    } else
      for (t + B > d && (t = d - B), I = t; I >= 0; I--) {
        let S = !0;
        for (let v = 0; v < B; v++)
          if (F(r, I + v) !== F(e, v)) {
            S = !1;
            break;
          }
        if (S)
          return I;
      }
    return -1;
  }
  c.prototype.includes = function(e, t, n) {
    return this.indexOf(e, t, n) !== -1;
  }, c.prototype.indexOf = function(e, t, n) {
    return _e(this, e, t, n, !0);
  }, c.prototype.lastIndexOf = function(e, t, n) {
    return _e(this, e, t, n, !1);
  };
  function Ye(r, e, t, n) {
    t = Number(t) || 0;
    const a = r.length - t;
    n ? (n = Number(n), n > a && (n = a)) : n = a;
    const u = e.length;
    n > u / 2 && (n = u / 2);
    let d;
    for (d = 0; d < n; ++d) {
      const B = parseInt(e.substr(d * 2, 2), 16);
      if (he(B))
        return d;
      r[t + d] = B;
    }
    return d;
  }
  function Xe(r, e, t, n) {
    return ie(ce(e, r.length - t), r, t, n);
  }
  function Je(r, e, t, n) {
    return ie(ht(e), r, t, n);
  }
  function Ke(r, e, t, n) {
    return ie(Te(e), r, t, n);
  }
  function Ze(r, e, t, n) {
    return ie(ut(e, r.length - t), r, t, n);
  }
  c.prototype.write = function(e, t, n, a) {
    if (t === void 0)
      a = "utf8", n = this.length, t = 0;
    else if (n === void 0 && typeof t == "string")
      a = t, n = this.length, t = 0;
    else if (isFinite(t))
      t = t >>> 0, isFinite(n) ? (n = n >>> 0, a === void 0 && (a = "utf8")) : (a = n, n = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const u = this.length - t;
    if ((n === void 0 || n > u) && (n = u), e.length > 0 && (n < 0 || t < 0) || t > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    a || (a = "utf8");
    let d = !1;
    for (; ; )
      switch (a) {
        case "hex":
          return Ye(this, e, t, n);
        case "utf8":
        case "utf-8":
          return Xe(this, e, t, n);
        case "ascii":
        case "latin1":
        case "binary":
          return Je(this, e, t, n);
        case "base64":
          return Ke(this, e, t, n);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Ze(this, e, t, n);
        default:
          if (d)
            throw new TypeError("Unknown encoding: " + a);
          a = ("" + a).toLowerCase(), d = !0;
      }
  }, c.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function et(r, e, t) {
    return e === 0 && t === r.length ? i.fromByteArray(r) : i.fromByteArray(r.slice(e, t));
  }
  function ve(r, e, t) {
    t = Math.min(r.length, t);
    const n = [];
    let a = e;
    for (; a < t; ) {
      const u = r[a];
      let d = null, B = u > 239 ? 4 : u > 223 ? 3 : u > 191 ? 2 : 1;
      if (a + B <= t) {
        let F, I, S, v;
        switch (B) {
          case 1:
            u < 128 && (d = u);
            break;
          case 2:
            F = r[a + 1], (F & 192) === 128 && (v = (u & 31) << 6 | F & 63, v > 127 && (d = v));
            break;
          case 3:
            F = r[a + 1], I = r[a + 2], (F & 192) === 128 && (I & 192) === 128 && (v = (u & 15) << 12 | (F & 63) << 6 | I & 63, v > 2047 && (v < 55296 || v > 57343) && (d = v));
            break;
          case 4:
            F = r[a + 1], I = r[a + 2], S = r[a + 3], (F & 192) === 128 && (I & 192) === 128 && (S & 192) === 128 && (v = (u & 15) << 18 | (F & 63) << 12 | (I & 63) << 6 | S & 63, v > 65535 && v < 1114112 && (d = v));
        }
      }
      d === null ? (d = 65533, B = 1) : d > 65535 && (d -= 65536, n.push(d >>> 10 & 1023 | 55296), d = 56320 | d & 1023), n.push(d), a += B;
    }
    return tt(n);
  }
  const Ie = 4096;
  function tt(r) {
    const e = r.length;
    if (e <= Ie)
      return String.fromCharCode.apply(String, r);
    let t = "", n = 0;
    for (; n < e; )
      t += String.fromCharCode.apply(
        String,
        r.slice(n, n += Ie)
      );
    return t;
  }
  function rt(r, e, t) {
    let n = "";
    t = Math.min(r.length, t);
    for (let a = e; a < t; ++a)
      n += String.fromCharCode(r[a] & 127);
    return n;
  }
  function it(r, e, t) {
    let n = "";
    t = Math.min(r.length, t);
    for (let a = e; a < t; ++a)
      n += String.fromCharCode(r[a]);
    return n;
  }
  function nt(r, e, t) {
    const n = r.length;
    (!e || e < 0) && (e = 0), (!t || t < 0 || t > n) && (t = n);
    let a = "";
    for (let u = e; u < t; ++u)
      a += lt[r[u]];
    return a;
  }
  function ot(r, e, t) {
    const n = r.slice(e, t);
    let a = "";
    for (let u = 0; u < n.length - 1; u += 2)
      a += String.fromCharCode(n[u] + n[u + 1] * 256);
    return a;
  }
  c.prototype.slice = function(e, t) {
    const n = this.length;
    e = ~~e, t = t === void 0 ? n : ~~t, e < 0 ? (e += n, e < 0 && (e = 0)) : e > n && (e = n), t < 0 ? (t += n, t < 0 && (t = 0)) : t > n && (t = n), t < e && (t = e);
    const a = this.subarray(e, t);
    return Object.setPrototypeOf(a, c.prototype), a;
  };
  function $(r, e, t) {
    if (r % 1 !== 0 || r < 0)
      throw new RangeError("offset is not uint");
    if (r + e > t)
      throw new RangeError("Trying to access beyond buffer length");
  }
  c.prototype.readUintLE = c.prototype.readUIntLE = function(e, t, n) {
    e = e >>> 0, t = t >>> 0, n || $(e, t, this.length);
    let a = this[e], u = 1, d = 0;
    for (; ++d < t && (u *= 256); )
      a += this[e + d] * u;
    return a;
  }, c.prototype.readUintBE = c.prototype.readUIntBE = function(e, t, n) {
    e = e >>> 0, t = t >>> 0, n || $(e, t, this.length);
    let a = this[e + --t], u = 1;
    for (; t > 0 && (u *= 256); )
      a += this[e + --t] * u;
    return a;
  }, c.prototype.readUint8 = c.prototype.readUInt8 = function(e, t) {
    return e = e >>> 0, t || $(e, 1, this.length), this[e];
  }, c.prototype.readUint16LE = c.prototype.readUInt16LE = function(e, t) {
    return e = e >>> 0, t || $(e, 2, this.length), this[e] | this[e + 1] << 8;
  }, c.prototype.readUint16BE = c.prototype.readUInt16BE = function(e, t) {
    return e = e >>> 0, t || $(e, 2, this.length), this[e] << 8 | this[e + 1];
  }, c.prototype.readUint32LE = c.prototype.readUInt32LE = function(e, t) {
    return e = e >>> 0, t || $(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + this[e + 3] * 16777216;
  }, c.prototype.readUint32BE = c.prototype.readUInt32BE = function(e, t) {
    return e = e >>> 0, t || $(e, 4, this.length), this[e] * 16777216 + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
  }, c.prototype.readBigUInt64LE = b(function(e) {
    e = e >>> 0, j(e, "offset");
    const t = this[e], n = this[e + 7];
    (t === void 0 || n === void 0) && X(e, this.length - 8);
    const a = t + this[++e] * 2 ** 8 + this[++e] * 2 ** 16 + this[++e] * 2 ** 24, u = this[++e] + this[++e] * 2 ** 8 + this[++e] * 2 ** 16 + n * 2 ** 24;
    return BigInt(a) + (BigInt(u) << BigInt(32));
  }), c.prototype.readBigUInt64BE = b(function(e) {
    e = e >>> 0, j(e, "offset");
    const t = this[e], n = this[e + 7];
    (t === void 0 || n === void 0) && X(e, this.length - 8);
    const a = t * 2 ** 24 + this[++e] * 2 ** 16 + this[++e] * 2 ** 8 + this[++e], u = this[++e] * 2 ** 24 + this[++e] * 2 ** 16 + this[++e] * 2 ** 8 + n;
    return (BigInt(a) << BigInt(32)) + BigInt(u);
  }), c.prototype.readIntLE = function(e, t, n) {
    e = e >>> 0, t = t >>> 0, n || $(e, t, this.length);
    let a = this[e], u = 1, d = 0;
    for (; ++d < t && (u *= 256); )
      a += this[e + d] * u;
    return u *= 128, a >= u && (a -= Math.pow(2, 8 * t)), a;
  }, c.prototype.readIntBE = function(e, t, n) {
    e = e >>> 0, t = t >>> 0, n || $(e, t, this.length);
    let a = t, u = 1, d = this[e + --a];
    for (; a > 0 && (u *= 256); )
      d += this[e + --a] * u;
    return u *= 128, d >= u && (d -= Math.pow(2, 8 * t)), d;
  }, c.prototype.readInt8 = function(e, t) {
    return e = e >>> 0, t || $(e, 1, this.length), this[e] & 128 ? (255 - this[e] + 1) * -1 : this[e];
  }, c.prototype.readInt16LE = function(e, t) {
    e = e >>> 0, t || $(e, 2, this.length);
    const n = this[e] | this[e + 1] << 8;
    return n & 32768 ? n | 4294901760 : n;
  }, c.prototype.readInt16BE = function(e, t) {
    e = e >>> 0, t || $(e, 2, this.length);
    const n = this[e + 1] | this[e] << 8;
    return n & 32768 ? n | 4294901760 : n;
  }, c.prototype.readInt32LE = function(e, t) {
    return e = e >>> 0, t || $(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
  }, c.prototype.readInt32BE = function(e, t) {
    return e = e >>> 0, t || $(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
  }, c.prototype.readBigInt64LE = b(function(e) {
    e = e >>> 0, j(e, "offset");
    const t = this[e], n = this[e + 7];
    (t === void 0 || n === void 0) && X(e, this.length - 8);
    const a = this[e + 4] + this[e + 5] * 2 ** 8 + this[e + 6] * 2 ** 16 + (n << 24);
    return (BigInt(a) << BigInt(32)) + BigInt(t + this[++e] * 2 ** 8 + this[++e] * 2 ** 16 + this[++e] * 2 ** 24);
  }), c.prototype.readBigInt64BE = b(function(e) {
    e = e >>> 0, j(e, "offset");
    const t = this[e], n = this[e + 7];
    (t === void 0 || n === void 0) && X(e, this.length - 8);
    const a = (t << 24) + // Overflow
    this[++e] * 2 ** 16 + this[++e] * 2 ** 8 + this[++e];
    return (BigInt(a) << BigInt(32)) + BigInt(this[++e] * 2 ** 24 + this[++e] * 2 ** 16 + this[++e] * 2 ** 8 + n);
  }), c.prototype.readFloatLE = function(e, t) {
    return e = e >>> 0, t || $(e, 4, this.length), o.read(this, e, !0, 23, 4);
  }, c.prototype.readFloatBE = function(e, t) {
    return e = e >>> 0, t || $(e, 4, this.length), o.read(this, e, !1, 23, 4);
  }, c.prototype.readDoubleLE = function(e, t) {
    return e = e >>> 0, t || $(e, 8, this.length), o.read(this, e, !0, 52, 8);
  }, c.prototype.readDoubleBE = function(e, t) {
    return e = e >>> 0, t || $(e, 8, this.length), o.read(this, e, !1, 52, 8);
  };
  function U(r, e, t, n, a, u) {
    if (!c.isBuffer(r))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (e > a || e < u)
      throw new RangeError('"value" argument is out of bounds');
    if (t + n > r.length)
      throw new RangeError("Index out of range");
  }
  c.prototype.writeUintLE = c.prototype.writeUIntLE = function(e, t, n, a) {
    if (e = +e, t = t >>> 0, n = n >>> 0, !a) {
      const B = Math.pow(2, 8 * n) - 1;
      U(this, e, t, n, B, 0);
    }
    let u = 1, d = 0;
    for (this[t] = e & 255; ++d < n && (u *= 256); )
      this[t + d] = e / u & 255;
    return t + n;
  }, c.prototype.writeUintBE = c.prototype.writeUIntBE = function(e, t, n, a) {
    if (e = +e, t = t >>> 0, n = n >>> 0, !a) {
      const B = Math.pow(2, 8 * n) - 1;
      U(this, e, t, n, B, 0);
    }
    let u = n - 1, d = 1;
    for (this[t + u] = e & 255; --u >= 0 && (d *= 256); )
      this[t + u] = e / d & 255;
    return t + n;
  }, c.prototype.writeUint8 = c.prototype.writeUInt8 = function(e, t, n) {
    return e = +e, t = t >>> 0, n || U(this, e, t, 1, 255, 0), this[t] = e & 255, t + 1;
  }, c.prototype.writeUint16LE = c.prototype.writeUInt16LE = function(e, t, n) {
    return e = +e, t = t >>> 0, n || U(this, e, t, 2, 65535, 0), this[t] = e & 255, this[t + 1] = e >>> 8, t + 2;
  }, c.prototype.writeUint16BE = c.prototype.writeUInt16BE = function(e, t, n) {
    return e = +e, t = t >>> 0, n || U(this, e, t, 2, 65535, 0), this[t] = e >>> 8, this[t + 1] = e & 255, t + 2;
  }, c.prototype.writeUint32LE = c.prototype.writeUInt32LE = function(e, t, n) {
    return e = +e, t = t >>> 0, n || U(this, e, t, 4, 4294967295, 0), this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = e & 255, t + 4;
  }, c.prototype.writeUint32BE = c.prototype.writeUInt32BE = function(e, t, n) {
    return e = +e, t = t >>> 0, n || U(this, e, t, 4, 4294967295, 0), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = e & 255, t + 4;
  };
  function Fe(r, e, t, n, a) {
    Ue(e, n, a, r, t, 7);
    let u = Number(e & BigInt(4294967295));
    r[t++] = u, u = u >> 8, r[t++] = u, u = u >> 8, r[t++] = u, u = u >> 8, r[t++] = u;
    let d = Number(e >> BigInt(32) & BigInt(4294967295));
    return r[t++] = d, d = d >> 8, r[t++] = d, d = d >> 8, r[t++] = d, d = d >> 8, r[t++] = d, t;
  }
  function Se(r, e, t, n, a) {
    Ue(e, n, a, r, t, 7);
    let u = Number(e & BigInt(4294967295));
    r[t + 7] = u, u = u >> 8, r[t + 6] = u, u = u >> 8, r[t + 5] = u, u = u >> 8, r[t + 4] = u;
    let d = Number(e >> BigInt(32) & BigInt(4294967295));
    return r[t + 3] = d, d = d >> 8, r[t + 2] = d, d = d >> 8, r[t + 1] = d, d = d >> 8, r[t] = d, t + 8;
  }
  c.prototype.writeBigUInt64LE = b(function(e, t = 0) {
    return Fe(this, e, t, BigInt(0), BigInt("0xffffffffffffffff"));
  }), c.prototype.writeBigUInt64BE = b(function(e, t = 0) {
    return Se(this, e, t, BigInt(0), BigInt("0xffffffffffffffff"));
  }), c.prototype.writeIntLE = function(e, t, n, a) {
    if (e = +e, t = t >>> 0, !a) {
      const F = Math.pow(2, 8 * n - 1);
      U(this, e, t, n, F - 1, -F);
    }
    let u = 0, d = 1, B = 0;
    for (this[t] = e & 255; ++u < n && (d *= 256); )
      e < 0 && B === 0 && this[t + u - 1] !== 0 && (B = 1), this[t + u] = (e / d >> 0) - B & 255;
    return t + n;
  }, c.prototype.writeIntBE = function(e, t, n, a) {
    if (e = +e, t = t >>> 0, !a) {
      const F = Math.pow(2, 8 * n - 1);
      U(this, e, t, n, F - 1, -F);
    }
    let u = n - 1, d = 1, B = 0;
    for (this[t + u] = e & 255; --u >= 0 && (d *= 256); )
      e < 0 && B === 0 && this[t + u + 1] !== 0 && (B = 1), this[t + u] = (e / d >> 0) - B & 255;
    return t + n;
  }, c.prototype.writeInt8 = function(e, t, n) {
    return e = +e, t = t >>> 0, n || U(this, e, t, 1, 127, -128), e < 0 && (e = 255 + e + 1), this[t] = e & 255, t + 1;
  }, c.prototype.writeInt16LE = function(e, t, n) {
    return e = +e, t = t >>> 0, n || U(this, e, t, 2, 32767, -32768), this[t] = e & 255, this[t + 1] = e >>> 8, t + 2;
  }, c.prototype.writeInt16BE = function(e, t, n) {
    return e = +e, t = t >>> 0, n || U(this, e, t, 2, 32767, -32768), this[t] = e >>> 8, this[t + 1] = e & 255, t + 2;
  }, c.prototype.writeInt32LE = function(e, t, n) {
    return e = +e, t = t >>> 0, n || U(this, e, t, 4, 2147483647, -2147483648), this[t] = e & 255, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24, t + 4;
  }, c.prototype.writeInt32BE = function(e, t, n) {
    return e = +e, t = t >>> 0, n || U(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = e & 255, t + 4;
  }, c.prototype.writeBigInt64LE = b(function(e, t = 0) {
    return Fe(this, e, t, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), c.prototype.writeBigInt64BE = b(function(e, t = 0) {
    return Se(this, e, t, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function $e(r, e, t, n, a, u) {
    if (t + n > r.length)
      throw new RangeError("Index out of range");
    if (t < 0)
      throw new RangeError("Index out of range");
  }
  function Ce(r, e, t, n, a) {
    return e = +e, t = t >>> 0, a || $e(r, e, t, 4), o.write(r, e, t, n, 23, 4), t + 4;
  }
  c.prototype.writeFloatLE = function(e, t, n) {
    return Ce(this, e, t, !0, n);
  }, c.prototype.writeFloatBE = function(e, t, n) {
    return Ce(this, e, t, !1, n);
  };
  function Re(r, e, t, n, a) {
    return e = +e, t = t >>> 0, a || $e(r, e, t, 8), o.write(r, e, t, n, 52, 8), t + 8;
  }
  c.prototype.writeDoubleLE = function(e, t, n) {
    return Re(this, e, t, !0, n);
  }, c.prototype.writeDoubleBE = function(e, t, n) {
    return Re(this, e, t, !1, n);
  }, c.prototype.copy = function(e, t, n, a) {
    if (!c.isBuffer(e))
      throw new TypeError("argument should be a Buffer");
    if (n || (n = 0), !a && a !== 0 && (a = this.length), t >= e.length && (t = e.length), t || (t = 0), a > 0 && a < n && (a = n), a === n || e.length === 0 || this.length === 0)
      return 0;
    if (t < 0)
      throw new RangeError("targetStart out of bounds");
    if (n < 0 || n >= this.length)
      throw new RangeError("Index out of range");
    if (a < 0)
      throw new RangeError("sourceEnd out of bounds");
    a > this.length && (a = this.length), e.length - t < a - n && (a = e.length - t + n);
    const u = a - n;
    return this === e && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(t, n, a) : Uint8Array.prototype.set.call(
      e,
      this.subarray(n, a),
      t
    ), u;
  }, c.prototype.fill = function(e, t, n, a) {
    if (typeof e == "string") {
      if (typeof t == "string" ? (a = t, t = 0, n = this.length) : typeof n == "string" && (a = n, n = this.length), a !== void 0 && typeof a != "string")
        throw new TypeError("encoding must be a string");
      if (typeof a == "string" && !c.isEncoding(a))
        throw new TypeError("Unknown encoding: " + a);
      if (e.length === 1) {
        const d = e.charCodeAt(0);
        (a === "utf8" && d < 128 || a === "latin1") && (e = d);
      }
    } else
      typeof e == "number" ? e = e & 255 : typeof e == "boolean" && (e = Number(e));
    if (t < 0 || this.length < t || this.length < n)
      throw new RangeError("Out of range index");
    if (n <= t)
      return this;
    t = t >>> 0, n = n === void 0 ? this.length : n >>> 0, e || (e = 0);
    let u;
    if (typeof e == "number")
      for (u = t; u < n; ++u)
        this[u] = e;
    else {
      const d = c.isBuffer(e) ? e : c.from(e, a), B = d.length;
      if (B === 0)
        throw new TypeError('The value "' + e + '" is invalid for argument "value"');
      for (u = 0; u < n - t; ++u)
        this[u + t] = d[u % B];
    }
    return this;
  };
  const H = {};
  function ae(r, e, t) {
    H[r] = class extends t {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: e.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${r}]`, this.stack, delete this.name;
      }
      get code() {
        return r;
      }
      set code(a) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: a,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${r}]: ${this.message}`;
      }
    };
  }
  ae(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(r) {
      return r ? `${r} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), ae(
    "ERR_INVALID_ARG_TYPE",
    function(r, e) {
      return `The "${r}" argument must be of type number. Received type ${typeof e}`;
    },
    TypeError
  ), ae(
    "ERR_OUT_OF_RANGE",
    function(r, e, t) {
      let n = `The value of "${r}" is out of range.`, a = t;
      return Number.isInteger(t) && Math.abs(t) > 2 ** 32 ? a = Ae(String(t)) : typeof t == "bigint" && (a = String(t), (t > BigInt(2) ** BigInt(32) || t < -(BigInt(2) ** BigInt(32))) && (a = Ae(a)), a += "n"), n += ` It must be ${e}. Received ${a}`, n;
    },
    RangeError
  );
  function Ae(r) {
    let e = "", t = r.length;
    const n = r[0] === "-" ? 1 : 0;
    for (; t >= n + 4; t -= 3)
      e = `_${r.slice(t - 3, t)}${e}`;
    return `${r.slice(0, t)}${e}`;
  }
  function st(r, e, t) {
    j(e, "offset"), (r[e] === void 0 || r[e + t] === void 0) && X(e, r.length - (t + 1));
  }
  function Ue(r, e, t, n, a, u) {
    if (r > t || r < e) {
      const d = typeof e == "bigint" ? "n" : "";
      let B;
      throw u > 3 ? e === 0 || e === BigInt(0) ? B = `>= 0${d} and < 2${d} ** ${(u + 1) * 8}${d}` : B = `>= -(2${d} ** ${(u + 1) * 8 - 1}${d}) and < 2 ** ${(u + 1) * 8 - 1}${d}` : B = `>= ${e}${d} and <= ${t}${d}`, new H.ERR_OUT_OF_RANGE("value", B, r);
    }
    st(n, a, u);
  }
  function j(r, e) {
    if (typeof r != "number")
      throw new H.ERR_INVALID_ARG_TYPE(e, "number", r);
  }
  function X(r, e, t) {
    throw Math.floor(r) !== r ? (j(r, t), new H.ERR_OUT_OF_RANGE(t || "offset", "an integer", r)) : e < 0 ? new H.ERR_BUFFER_OUT_OF_BOUNDS() : new H.ERR_OUT_OF_RANGE(
      t || "offset",
      `>= ${t ? 1 : 0} and <= ${e}`,
      r
    );
  }
  const at = /[^+/0-9A-Za-z-_]/g;
  function ct(r) {
    if (r = r.split("=")[0], r = r.trim().replace(at, ""), r.length < 2)
      return "";
    for (; r.length % 4 !== 0; )
      r = r + "=";
    return r;
  }
  function ce(r, e) {
    e = e || 1 / 0;
    let t;
    const n = r.length;
    let a = null;
    const u = [];
    for (let d = 0; d < n; ++d) {
      if (t = r.charCodeAt(d), t > 55295 && t < 57344) {
        if (!a) {
          if (t > 56319) {
            (e -= 3) > -1 && u.push(239, 191, 189);
            continue;
          } else if (d + 1 === n) {
            (e -= 3) > -1 && u.push(239, 191, 189);
            continue;
          }
          a = t;
          continue;
        }
        if (t < 56320) {
          (e -= 3) > -1 && u.push(239, 191, 189), a = t;
          continue;
        }
        t = (a - 55296 << 10 | t - 56320) + 65536;
      } else
        a && (e -= 3) > -1 && u.push(239, 191, 189);
      if (a = null, t < 128) {
        if ((e -= 1) < 0)
          break;
        u.push(t);
      } else if (t < 2048) {
        if ((e -= 2) < 0)
          break;
        u.push(
          t >> 6 | 192,
          t & 63 | 128
        );
      } else if (t < 65536) {
        if ((e -= 3) < 0)
          break;
        u.push(
          t >> 12 | 224,
          t >> 6 & 63 | 128,
          t & 63 | 128
        );
      } else if (t < 1114112) {
        if ((e -= 4) < 0)
          break;
        u.push(
          t >> 18 | 240,
          t >> 12 & 63 | 128,
          t >> 6 & 63 | 128,
          t & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return u;
  }
  function ht(r) {
    const e = [];
    for (let t = 0; t < r.length; ++t)
      e.push(r.charCodeAt(t) & 255);
    return e;
  }
  function ut(r, e) {
    let t, n, a;
    const u = [];
    for (let d = 0; d < r.length && !((e -= 2) < 0); ++d)
      t = r.charCodeAt(d), n = t >> 8, a = t % 256, u.push(a), u.push(n);
    return u;
  }
  function Te(r) {
    return i.toByteArray(ct(r));
  }
  function ie(r, e, t, n) {
    let a;
    for (a = 0; a < n && !(a + t >= e.length || a >= r.length); ++a)
      e[a + t] = r[a];
    return a;
  }
  function M(r, e) {
    return r instanceof e || r != null && r.constructor != null && r.constructor.name != null && r.constructor.name === e.name;
  }
  function he(r) {
    return r !== r;
  }
  const lt = function() {
    const r = "0123456789abcdef", e = new Array(256);
    for (let t = 0; t < 16; ++t) {
      const n = t * 16;
      for (let a = 0; a < 16; ++a)
        e[n + a] = r[t] + r[a];
    }
    return e;
  }();
  function b(r) {
    return typeof BigInt > "u" ? ft : r;
  }
  function ft() {
    throw new Error("BigInt not supported");
  }
})(me);
const Yt = (s) => {
  const i = me.Buffer.from(s, "base64").toString("utf8"), o = me.Buffer.from(i, "binary").toString("base64");
  return s === o ? i : s;
}, Xt = (s) => {
  const i = Yt(s), o = JSON.parse(i);
  return {
    rawString: s,
    message: i,
    ...o,
    ...o.date && o.sig ? { userAddress: Oe(o.date, o.sig) } : {},
    ...o.payload && o.sig ? { userAddress: Oe(o.payload, o.sig) } : {},
    ...o.scanType ? { scanType: o.scanType } : {},
    ...o.chainId ? { chainId: o.chainId } : {}
  };
};
class Ge {
  constructor(i) {
    this.events = {}, this._getMainCameraDeviceId = (h) => {
      var p, c;
      if (!(h != null && h.length))
        throw new Error("No video input devices available");
      const l = ["back", "задня"], f = h.find((y) => {
        const m = y.label.toLowerCase();
        return m.includes(l[0]) || m.includes(l[1]);
      });
      return (f == null ? void 0 : f.id) || ((p = h[1]) == null ? void 0 : p.id) || ((c = h[0]) == null ? void 0 : c.id);
    }, this.listVideoInputDevices = async () => _.listCameras(!0), this.scan = async ({ deviceId: h, maxScansPerSecond: l, isCloseButton: f } = {}) => {
      var p, c, y, m, w, E;
      f === void 0 && (f = !0), (p = this.qrScanner) == null || p.stop(), (c = this.rootElement) == null || c.remove(), new Nt({
        target: this.targetElement,
        props: { close: this.close, isCloseButton: f }
      }), this.rootElement = document.getElementById(te.ROOT);
      try {
        if (!h) {
          const g = await this.listVideoInputDevices();
          h = this._getMainCameraDeviceId(g);
        }
        this.qrScanner = new _(
          document.getElementById(te.VIDEO),
          (g) => {
            var x, C, R, O;
            if (this.previousScanText !== g.data)
              try {
                this.previousScanText = g.data, (C = (x = this.events) == null ? void 0 : x[G.CAPTURE]) == null || C.call(x, Xt(g.data));
              } catch (A) {
                (O = (R = this.events) == null ? void 0 : R[G.ERROR]) == null || O.call(R, A);
              }
          },
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          {
            returnDetailedScanResult: !0,
            maxScansPerSecond: l ?? 25,
            // might be changed
            preferredCamera: h,
            highlightScanRegion: !0,
            highlightCodeOutline: !0,
            onDecodeError: () => {
            }
          }
        ), await this.qrScanner.start();
      } catch (g) {
        (m = (y = this.events) == null ? void 0 : y[G.ERROR]) == null || m.call(y, g), (w = this.qrScanner) == null || w.stop(), (E = this.rootElement) == null || E.remove();
      }
    }, this.close = () => {
      var h, l, f, p;
      this.previousScanText = null, (l = (h = this.events) == null ? void 0 : h[G.CANCEL]) == null || l.call(h), (f = this.qrScanner) == null || f.stop(), (p = this.rootElement) == null || p.remove();
    }, this.on = (h, l) => this.events[h] = l, this.off = (h) => this.events[h] = void 0;
    const o = document.querySelector(i.target);
    if (!o)
      throw new Error(`Target element '${i.target}' is not found`);
    this.targetElement = o;
  }
}
Ge.events = G;
typeof window < "u" && (window.CredenzaScanner = Ge);
export {
  Ge as Scanner
};
